import { Injectable } from '@angular/core';
import { RepositoryService, UnitOfWorkService } from '@mri/breeze-entity';
import { MetadataStore } from 'breeze-client';
import { UserPrincipal } from '../models';
import { userQueries } from './queries';

@Injectable({ providedIn: 'root' })
export class UserRepositoryService extends RepositoryService<UserPrincipal> {
  constructor(uow: UnitOfWorkService, metadataStore: MetadataStore) {
    super(uow, metadataStore, userQueries.selectAll);
  }
}
